<template>
<div class="page-torch">
  <comm-banner :text="$t('pageTorch.title')" />
  <div class="container">
    <div v-for="(item,index) in list" :key="index" class="torch-group">
      <div class="torch-pic">
        <img :src="require(`./images/${item.pic}.png`)" alt="">
      </div>

      <div class="torch-info-grid">
        <div
          v-for="(res,resIndex) in item.list"
          :key="resIndex"
          class="torch-restaurant"
          :style="{
            width: item.list.length>1?'45%':'100% !important'
          }"
        >
          <div class="torch-restaurant-title">{{ res.title }}</div>

          <div class="torch-labels">
            <div v-for="(label,labelIndex) in res.labels" :key="labelIndex" class="torch-label">
              <span class="torch-label-text">{{ label.name }}&nbsp;&nbsp;</span>
              <span
                v-for="starIndex in getStarCount(label.star)"
                :key="`${labelIndex}-${starIndex}`"
                class="torch-star-count"
              />
              <span v-if="labelIndex!=res.labels.length-1" class="line">|</span>
            </div>
          </div>

          <div class="torch-address">
            <img :src="require('./images/icon-map.png')" alt="">
            <span class="torch-address-text">{{ res.address }}</span>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import CommBanner from "@/components/CommBanner/index.vue";
import {mapState} from "vuex";

export default {
  name: "Torch",
  components: {CommBanner},
  methods: {
    // star 可能来自后端字段，确保是非负整数
    getStarCount(star) {
      const n = Number.parseInt(star, 10);
      return Number.isNaN(n) ? 0 : Math.max(0, n);
    }
  },
  data(){
    return {
      listCn: [
        {
          pic: "pic-tz",
          list: [
            {
              title: "中国菜 · 头灶",
              labels: [
                {
                  name:"米其林指南 上海 2026",
                  star: 2
                },
                {
                  name:"米其林指南 上海 2025",
                  star: 1
                },
                {
                  name:"黑珍珠餐厅指南 上海 2024",
                  star: 0
                }
              ],
              address:"上海市静安区南京西路1376号上海商城东峰211室",
            }
          ],
        },
        {
          pic: "pic-NARISAWA",
          list: [
            {
              title: "NARISAWA SHANGHAI",
              labels: [
                {
                  name:"米其林指南 上海 2025",
                  star: 1
                },
              ],
              address:"上海市普陀区莫干山路600号天安千树7楼",
            },
            {
              title: "NARISAWA",
              labels: [
                {
                  name:"米其林指南 东京 2025",
                  star: 2
                },
                {
                  name:"The World's 50 Best Restaurants #21",
                  star: 0
                },
              ],
              address:"日本东京都港区南青山2-6-15",
            }
          ],
        },
        {
          pic: "pic-TAKIYA",
          list: [
            {
              title: "TAKIYA SHANGHAI",
              labels: [
                {
                  name:"2026年开业",
                  star: 0
                }
              ],
              address:"上海市黄浦区中山东一路32号上海半岛酒店B1N",
            },
            {
              title: "TAKIYA",
              labels: [
                {
                  name:"Tabelog “百名店”",
                  star: 0
                },
                {
                  name:"2025“天妇罗”银奖”",
                  star: 0
                },
                {
                  name:"2024“天妇罗”金奖",
                  star: 0
                }
              ],
              address:"日本东京都港区麻布十番2-8-6",
            }
          ],
        }
      ],
      listEn: [
        {
          pic: "pic-tz",
          list: [
            {
              title: "TOUZAO",
              labels: [
                {
                  name:"The MICHELIN Guide SHANGHAI 2026 ",
                  star: 2
                },
                {
                  name:"The MICHELIN Guide SHANGHAI 2025 ",
                  star: 1
                },
                {
                  name:"Black Pearl Restaurant Guide SHANGHAI 2024",
                  star: 0
                }
              ],
              address:"Room 211, East Tower, Shanghai Centre, 1376 West Nanjing Road, Jing'an District, Shanghai\n",
            }
          ],
        },
        {
          pic: "pic-NARISAWA",
          list: [
            {
              title: "NARISAWA SHANGHAI",
              labels: [
                {
                  name:"The MICHELIN Guide SHANGHAI 2025",
                  star: 1
                },
              ],
              address:"7th Floor, 1000 Trees, No. 600 Moganshan Road, Putuo District, Shanghai",
            },
            {
              title: "NARISAWA",
              labels: [
                {
                  name:"The MICHELIN Guide TOKYO 2025",
                  star: 2
                },
                {
                  name:"The World's 50 Best Restaurants #21",
                  star: 0
                },
              ],
              address:"2 Chome-6-15 Minamiaoyama, Minato City, Tokyo 107-0062",
            }
          ],
        },
        {
          pic: "pic-TAKIYA",
          list: [
            {
              title: "TAKIYA SHANGHAI",
              labels: [
                {
                  name:"Opening on April 1, 2026",
                  star: 0
                }
              ],
              address:"B1N, The Peninsula Shanghai, No. 32 Zhongshan East 1st Road, Huangpu District, Shanghai",
            },
            {
              title: "TAKIYA",
              labels: [
                {
                  name:"Tabelog 100” 2025",
                  star: 0
                },
                {
                  name:"Tabelog 2026 Gold Winner",
                  star: 0
                },
                // {
                //   name:"2024“天妇罗”金奖",
                //   star: 0
                // }
              ],
              address:"2 Chome−8−6 Azabujuban, Minato City, Tokyo 106-0045",
            }
          ],
        }
      ]
    }
  },
  computed:{
    ...mapState(['lang']),
    list(){
      return this.lang === 'zh' ? this.listCn : this.listEn;
    }
  }
}
</script>

<style scoped lang="scss">
.page-torch {
  padding-bottom: 80px;

  > .container {
    padding-top: 48px;
  }

  .torch-group {
    height: 240px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.04);
    border-radius: 8px;
    padding: 0 48px 0 24px;
    box-sizing: border-box;
  }

  .torch-pic {
    width: 278px;
    height: 172px;
    margin-right: 4px;
    >img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  .torch-info-grid {
    flex: 1;
    display: flex;
    >div.torch-restaurant{
      &:first-child{
        width: 40%;
      }
    }
  }

  .torch-restaurant {
    padding-top: 6px;
  }

  .torch-restaurant-empty {
    visibility: hidden;
  }

  .torch-restaurant-title {
    font-size: 20px;
    font-weight: 600;
    color: #231916;
    line-height: 32px;
    margin-bottom: 16px;
  }

  .torch-labels {
    margin-bottom: 9px;
    display: flex;
    align-items: center;
  }

  .torch-label {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: rgba(35, 25, 22, 1);
    line-height: 32px;
  }

  .torch-label-icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    flex: 0 0 16px;

    &.muted {
      opacity: 0.35;
    }
  }

  .torch-label-text {
    display: inline-block;
    white-space: nowrap;
  }

  .torch-star-count {
    width: 18px;
    height: 18px;
    background: url("./images/icon-star.png") no-repeat;
    background-size: 100% 100%;
    margin-top: -2px;
  }
  .line{
    padding-left: 20px;
    padding-right: 20px;
    margin-top: -2px;
  }

  .torch-address {
    display: flex;
    margin-top: 6px;
    padding-top: 6px;
    padding-bottom: 6px;
    align-items: flex-start;

    > img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
      flex: 0 0 16px;
      margin-top: 3px;
    }
  }

  .torch-address-text {
    font-size: 16px;
    color: rgba(35, 25, 22, 1);
    line-height: 20px;
    padding-top: 2px;
  }
}
</style>
